module.exports = __webpack_public_path__ + "static/img/rect-tips-long.ea13fcbc.png";